import styled from 'styled-components'

export const Container = styled.ol`
  margin-bottom: 16px;
`
